import { Tooltip } from '@/common/ui';
import { Tooltip as TooltipImg } from '@/shared/images/icons/Tooltip';
import { cssVars } from '@/styles/Themes/cssVars';
import Text from '@/styles/Themes/Text';
import styled from 'styled-components';
import Screen from '@/styles/Themes/Screen';

type TReviewsRecommended = {
    reviewsCount: number;
    rateRecommended?: string;
};

const MIN_REVIEWS_COUNT = 10;

export const ReviewsRecommended = ({ reviewsCount, rateRecommended }: TReviewsRecommended) => {
    if (!rateRecommended || reviewsCount < MIN_REVIEWS_COUNT) {
        return <></>;
    }

    return (
        <Wrapper>
            <Message>
                <img src="/image/ShopperApprovedCheck.svg" alt="Shopper Approved Recommended" />
                {`Recommended by ${rateRecommended}% of travelers `}
                <Tooltip
                    description={
                        <span>
                            This figure is based off the amount of 4 and 5 star reviews for this
                            activity.
                        </span>
                    }
                    inCart={false}
                >
                    <TooltipIcon />
                </Tooltip>
            </Message>
        </Wrapper>
    );
};

const Wrapper = styled.div`
    position: relative;
    height: 32px;
    width: 100px;

    ${Screen.desktop} {
        width: auto;
        height: auto;
    }
`;

const Message = styled.div`
    ${Text.Full.large.regular}
    position: absolute;
    background-color: ${cssVars.bg_ashDarker_blueDark};
    color: ${cssVars.fg_gray2_gray3};

    padding: 4px 10px 2px 36px;
    border-radius: 50px;
    width: 312px;

    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: nowrap;
    margin-top: 6px;

    ${Screen.ipad} {
        width: 348px;
    }

    ${Screen.desktop} {
        position: relative;
        width: auto;
    }

    img {
        position: absolute;
        left: 0;

        ${Screen.ipad} {
            top: 0;
        }
    }
`;

export const TooltipIcon = styled(TooltipImg)`
    width: 12px;
    height: 12px;
    stroke: ${cssVars.fg_gray1_white};
    cursor: pointer;

    margin: 4px 0 0 4px;
`;
